/**
 * @internal
 */
export function getEnvFromCheckoutUrl(checkoutUrl?: string | null): string {
  if (!checkoutUrl) {
    return "live";
  }

  if (checkoutUrl.match(/.*test.*/)) {
    return "test";
  }

  if (checkoutUrl.match(/.*live-us.*/)) {
    return "live-us";
  }

  if (checkoutUrl.match(/.*live-au.*/)) {
    return "live-au";
  }

  if (checkoutUrl.match(/.*live-apse.*/)) {
    return "live-apse";
  }

  if (checkoutUrl.match(/.*live-in.*/)) {
    return "live-in";
  }

  return "live";
}
